import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export class DAWASearch {
    constructor(private http:HttpClient){}

    address(search:string, zip?:string):Observable<DAWA[]>{
        let post = '';
        if (!!zip && zip != '') { post = '&postnr=' + zip; }
        return this.http.get<DAWA[]>('https://dawa.aws.dk/adresser/autocomplete?q=' + search + post)
    }

    address2(search:string, zip?:string):Observable<DAWA[]>{
        let post = '';
        if (!!zip && zip != '') { post = '&postnr=' + zip; }
        let text = `${search}*${ !!zip ? '&postnr=' + zip : '' }&fuzzy=`
        return this.http.get<DAWA[]>('https://api.dataforsyningen.dk/adresser/autocomplete?q=' + text)
    }

    cityByZip(zip):Observable<any>{
        return this.http.get('https://dawa.aws.dk/postnumre/?nr=' + zip)
    }

    vat(vat:string, languageId:string){
        return new Observable(obs => {
            switch(languageId){
                // case 'sv-SE': {
                //     obs.next(vat);
                //     obs.complete()
                // }
                case 'nn-NO': {
                    this.http.get('https://data.brreg.no/enhetsregisteret/api/enheter/' + vat).subscribe({
                        next:(data) => { obs.next(data); obs.complete() }
                    });
                    break
                }
                case 'da-DK': {
                    this.http.get('https://cvrapi.dk/api?search=' + vat + '&country=dk&token=8scfm3rphhdu3ardgv8ttev9fyqnammm').subscribe({
                        next:(data:DawaCvrSearchResult) => { obs.next(DawaFunctions.transformDawaCvrSearchResult(data)) },
                        error:(err) => { obs.error(err) },
                        complete:()=> obs.complete()
                    });
                    break
                }
                default: obs.complete()
            }
        })
    }
}

export class DAWA {
    public adresse: Address;
    public tekst: string;
  }
  
export class Address {
public adgangsadresseid: string;
public adresseringsvejnavn: string;
public darstatus: number;
public dør: string;
public etage: string;
public href: URL;
public husnr: string;
public id: string;
public kommunekode: string;
public postnr:string;
public postnrnavn:string;
public status: number;
public stormodtagerpostnr: string;
public stormodtagerpostnrnavn: string;
public supplerendebynavn: string;
public vejkode: string;
public vejnavn: string;
public x: any;
public y: any;
}

interface DawaCvrSearchResult {
    vat: number;
    name: string;
    address: string;
    zipcode: string;
    city: string;
    cityname: string | null;
    protected: boolean;
    phone: string | null;
    email: string | null;
    fax: string | null;
    startdate: string | null;
    enddate: string | null;
    employees: number;
    addressco: string | null;
    industrycode: number;
    industrydesc: string;
    companycode: number;
    companydesc: string;
    creditstartdate: string | null;
    creditbankrupt: boolean;
    creditstatus: string | null;
    owners: any[] | null;
    productionunits: {
        pno: number;
        main: boolean;
        name: string;
        address: string;
        zipcode: string;
        city: string;
        cityname: string | null;
        protected: boolean;
        phone: string | null;
        email: string | null;
        fax: string | null;
        startdate: string | null;
        enddate: string | null;
        employees: number;
        addressco: string | null;
        industrycode: number;
        industrydesc: string;
    }[];
    t: number;
    version: number;
}

export interface CompanyData {
    vat: number;
    name: string;
    address: string;
    zipcode: string;
    city: string;
    phone: string;
    email: string;
}

export class DawaFunctions {
    static transformDawaCvrSearchResult(result: DawaCvrSearchResult): CompanyData {
        return {
            vat: result.vat,
            name: result.name,
            address: result.address,
            zipcode: result.zipcode,
            city: result.city,
            phone: result.phone ?? '',
            email: result.email ?? '',
        };
    }
    static getCompleteAddress(dawaAddress: DAWA): string {
        const { vejnavn, husnr, etage, dør } = dawaAddress.adresse;
        let addressString = `${vejnavn}`;
        if (husnr) { addressString += ` ${husnr}`; }
        if (etage) { addressString += `, ${etage}.`; }
        if (dør) { addressString += ` ${dør}.`; }
        return addressString;
      }
}